import PropTypes from 'prop-types';

import { ProgressMulti } from 'twyne-new.ui';

import ProgressBar from './ProgressBar';

const propTypes = {
  paths: PropTypes.array,
  total: PropTypes.numer,
  getLabel: PropTypes.func,
  onToggleManage: PropTypes.func,
  active: PropTypes.bool,
};

export default function ProgressCollapse({ paths, total, getLabel, onToggleManage }) {
  if (!paths || !paths.length) return null

  return <ProgressMulti fadeColor>
    {paths.map((item, idx) => {
      const percentage = (item.weigth / total) * 100
      const id = `progress-${item.id}-${item.path_id}-${idx}`
      const label = getLabel(item.path_id)
      const progressLabel = `${item.path_id ? ` [#${item.path_id}]` : ''} ${label ? `${label} - ` : ''} ${percentage.toFixed(0)}%`

      return <ProgressBar
        index={idx}
        key={id}
        id={id}
        value={percentage}
        label={progressLabel}
        onClick={() => onToggleManage(idx)}
      />
    },
    )}
  </ProgressMulti>
}

ProgressCollapse.propTypes = propTypes
ProgressCollapse.defaultProps = {}
